var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('RContextMenu',{staticClass:"user-menu",attrs:{"items":_vm.items,"position":"right: 0; top: 42px;"}},[_c('ProfileImage',{staticClass:"profile-image",attrs:{"addShadow":true,"imageURL":_vm.photoURL}}),_c('span',{staticClass:"user-menu__name"},[_vm._v(_vm._s(_vm.name)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }